// //mr Dong create file


// (() => {
//   const LABEL = 'label[for^="rapi-bundles-deal-"]';
//   const PRICE = '.rapi-bundles__bar-price';
//   const BTN   = 'button[name="add"]';
//   const BTN_PRICE = '.total-price__detail';
//   let lastPrice = null;

//   const updateAll = (t) => {
//     if (!t) return;
//     lastPrice = t;
//     document.querySelectorAll(BTN).forEach(btn => {
//       const span = btn.querySelector(BTN_PRICE);
//       if (span) {
//         span.textContent = t;
//         // cập nhật luôn data-total_price nếu có (cho theme/JS khác dùng)
//         const cents = Math.round(parseFloat(t.replace(/[^0-9.]/g,'')) * 100);
//         if (!isNaN(cents)) span.setAttribute('data-total_price', String(cents));
//       } else {
//         btn.textContent = `.Add to Cart – ${t}`;
//       }
//     });
//   };

//   const getPrice = () =>
//     document.querySelector('.rapi-bundles__bar[aria-checked="true"] ' + PRICE)?.textContent?.trim()
//     || document.querySelectorAll(LABEL)[1]?.querySelector(PRICE)?.textContent?.trim()
//     || document.querySelector(LABEL + ' ' + PRICE)?.textContent?.trim();

//   // click offer → cập nhật giá cho cả 2 nút
//   document.addEventListener('click', e => {
//     const p = e.target.closest(LABEL)?.querySelector(PRICE)?.textContent?.trim();
//     if (p) updateAll(p);
//   }, { passive: true });

//   const init = () => { const p = getPrice(); console.log(p); if (p) { updateAll(p); return true; } return false; };

//   window.addEventListener('load', () => {

//     init();
//  console.log("window ready");
//     // nút sticky render muộn → khi thấy button mới xuất hiện thì apply lại giá cuối cùng
//     const obs = new MutationObserver(muts => {
//       let addedBtn = false;
//       for (const m of muts) {
//         m.addedNodes && m.addedNodes.forEach(n => {
//           if (n.nodeType === 1 && (n.matches?.(BTN) || n.querySelector?.(BTN))) addedBtn = true;
//         });
//       }
//       if (addedBtn && lastPrice) updateAll(lastPrice);
//       // cũng thử init nếu bundle vừa được inject
//       if (!lastPrice) init();
//     });
//     obs.observe(document.body, { childList: true, subtree: true });
//   });
// })();

(() => {
  const LABEL      = 'label[for^="rapi-bundles-deal-"]';
  const RADIO      = 'input[id^="rapi-bundles-deal-"]';
  const PRICE      = '.rapi-bundles__bar-price';
  const BTN        = 'button[name="add"]';
  const BTN_PRICE  = '.total-price__detail';
  let lastPrice = null;

  const updateAll = (t) => {
    if (!t) return;
    lastPrice = t;
    document.querySelectorAll(BTN).forEach(btn => {
      const span = btn.querySelector(BTN_PRICE);
      if (span) {
        span.textContent = t;
        const cents = Math.round(parseFloat(t.replace(/[^0-9.]/g,'')) * 100);
        if (!isNaN(cents)) span.setAttribute('data-total_price', String(cents));
      } else {
        btn.textContent = `Add to Cart – ${t}`;
      }
    });
  };

  // LẤY GIÁ TỪ RADIO ĐANG CHỌN
  const getPrice = () => {
    // radio đang checked (ưu tiên thuộc tính checked, nếu không có thì lấy cái đầu tiên)
    const checked =
      document.querySelector(`${RADIO}:checked`) ||
      document.querySelector(RADIO);

    if (!checked) return null;

    const label = document.querySelector(`label[for="${checked.id}"] ${PRICE}`);
    return label?.textContent?.trim() || null;
  };

  // bất kỳ click nào bên trong bundle → đọc lại radio đang chọn rồi update
  document.addEventListener('click', e => {
    if (!e.target.closest('.rapi-bundles')) return;
    const p = getPrice();
    if (p) updateAll(p);
  }, { passive: true });

  const init = () => {
    const p = getPrice();
    //console.log('init price:', p);
    if (p) {
      updateAll(p);
      return true;
    }
    return false;
  };

  window.addEventListener('load', () => {
    init();
    //console.log('window ready');

    const obs = new MutationObserver(muts => {
      let addedBtn = false;
      for (const m of muts) {
        m.addedNodes && m.addedNodes.forEach(n => {
          if (n.nodeType === 1 && (n.matches?.(BTN) || n.querySelector?.(BTN))) {
            addedBtn = true;
          }
        });
      }
      if (addedBtn && lastPrice) updateAll(lastPrice);
      if (!lastPrice) init();
    });
    obs.observe(document.body, { childList: true, subtree: true });
  });
})();

